import React, { useRef, useCallback } from 'react';
import { HotKeys, configure } from '../common/library/HotKeys/react-hotkeys';
import useMsgCallback from '@web-common/hooks/useMsgCallback';
configure({
    ignoreRepeatedEventsWhenKeyHeldDown: false,
});
const useModuleHotKeys = (routerName) => {
    const eventForward = useRef(null);
    useMsgCallback('keyboard', event => {
        const curRouter = window.location.hash;
        const activeElement = document.activeElement;
        if (`#${routerName}` === curRouter && (activeElement === document.body || activeElement === document.getElementById('gatsby-focus-wrapper'))) {
            eventForward.current && eventForward.current(event.eventData);
        }
    });
    const ModuleHK = useCallback(props => (React.createElement(HotKeys, Object.assign({ id: "mailboxhotkey" }, Object.assign(Object.assign({}, props), { children: undefined }), { getEventForward: callback => {
            eventForward.current = callback;
        } }), props.children)), []);
    return ModuleHK;
};
export default useModuleHotKeys;
